// Displayed wording and accessibility labels only. Never change input values, URLs, IDs or stored facts.
const ignored = 'script,style,textarea,input,select,option,pre,code,svg,[contenteditable],[data-consent-text]';
function cleanText(value) {
  if (value.includes('://') || value.includes('@')) return value;
  return value
    .replace(/(\d)[\u002d\u2013\u2014](?=\d)/g, '$1 to ')
    .replace(/\s*[\u2013\u2014]\s*/g, ', ')
    .replace(/(\p{L})[\u002d\u2010\u2011](?=\p{L})/gu, '$1 ')
    .replace(/\s+\u002d\s+/g, ', ');
}
function tidyLabels(root) {
  if (root.nodeType !== Node.ELEMENT_NODE) return;
  for (const element of [root, ...root.querySelectorAll('[aria-label],[title],[placeholder]')]) {
    for (const attribute of ['aria-label', 'title', 'placeholder']) {
      const value = element.getAttribute(attribute);
      if (value) {
        const next = cleanText(value);
        if (next !== value) element.setAttribute(attribute, next);
      }
    }
  }
}
function tidy(root) {
  if (root?.nodeType === Node.ELEMENT_NODE) tidyLabels(root);
  if (!root || root.nodeType !== Node.ELEMENT_NODE || root.closest(ignored)) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (!node.parentElement?.closest(ignored)) {
      const next = cleanText(node.data);
      if (next !== node.data) node.data = next;
    }
  }
}
tidy(document.body);
const observer = new MutationObserver(records => {
  for (const record of records) {
    if (record.type === 'attributes') {
      tidyLabels(record.target);
    } else if (record.type === 'characterData') {
      const node = record.target;
      if (!node.parentElement?.closest(ignored)) {
        const next = cleanText(node.data);
        if (next !== node.data) node.data = next;
      }
    } else {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.TEXT_NODE && !node.parentElement?.closest(ignored)) {
          const next = cleanText(node.data);
          if (next !== node.data) node.data = next;
        } else tidy(node);
      }
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title', 'placeholder'] });
